var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lib-accordion-category" }, [
    _c(
      "div",
      {
        staticClass: "lib-accordion-category-header",
        on: {
          click: function ($event) {
            _vm.manuallyExpanded = !_vm.manuallyExpanded
          },
        },
      },
      [
        _vm.expanded
          ? _c("span", { staticClass: "fa fa-caret-down" })
          : _c("span", { staticClass: "fa fa-caret-right" }),
        _vm._v(" "),
        _vm._t("header"),
      ],
      2
    ),
    _vm._v(" "),
    _vm.expanded
      ? _c(
          "div",
          { staticClass: "lib-accordion-items" },
          _vm._l(_vm.children, function (item) {
            return _c(
              "div",
              {
                staticClass: "lib-accordion-item",
                class: { _disabled: _vm.isDisabled && _vm.isDisabled(item) },
                on: {
                  click: function ($event) {
                    return _vm.$emit("clicked", item)
                  },
                },
              },
              [
                _vm.isSelected
                  ? [
                      _c("div", { staticClass: "lib-checkbox" }, [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: { checked: _vm.isSelected(item) },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lib-checkbox-visual" }),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm._t(
                  "default",
                  function () {
                    return [
                      _vm._v(
                        "\n                " + _vm._s(item) + "\n            "
                      ),
                    ]
                  },
                  { item: item }
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "lib-accordion-action" },
                  [_vm._t("action")],
                  2
                ),
              ],
              2
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }